import React  from 'react';
import './Information.scss';
import { ForwardIcon } from '../../assets/icon';

const DropdownWrapper = ({
                           label,
                           selectedItem,
                           getItemLabel,
                           isOpen,
                           setIsOpen,
  children,
  icon,
}) => {


  return (
    <div className="playlist-wrapper" onClick={() => setIsOpen(!isOpen)}>
      <div className="playlist-selection">
        {icon?<icon />:<ForwardIcon />}
        <span>{selectedItem === 'all' ? `All ${label}` : getItemLabel()}</span>
      </div>
      <i
        className={`feather-chevron-down ${
          isOpen ? 'playlist-open' : 'playlist-closed'
        }`}
      />

      {children}
    </div>
  );
};

export default DropdownWrapper;
